import { userStore } from '~/stores';
import { getCookieLang } from '~/utils/cookies';

export const getRequestLang = (serverLang?: string) =>
  serverLang || getCookieLang() || userStore.lang || '';

export const getLangHeaders = (serverLang?: string) => ({
  headers: { 'x-lang': getRequestLang(serverLang) },
});
